import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledActionButtons = styled.div`
    align-self: self-end;
    width: 25%;
    padding: 20px 0;
    @media ${breakpoints.xs} {
        width: 100%;
    }
`;
